// external link
export const URL_COOKIE_POLICY = 'https://www.schneider-electric.com/en/about-us/legal/data-privacy.jsp';
export const URL_TERMS_CONDITIONS = 'https://www.schneider-electric.com/en/about-us/legal/terms-of-use.jsp';
export const URL_USE = 'https://twinbusportal.westeurope.cloudapp.azure.com/use.html';
export const URL_RULE = 'https://twinbusportal.westeurope.cloudapp.azure.com/rule.html';

// export const URL_API_SERVER = window.domain.substr(0, 4) === 'http' ? window.domain
//   : `${window.location.protocol || 'https:'}//${window.domain}`;
export const PATH_API_AUTH = '/wiserdoor/data/token/';
export const PATH_API_CIAM_AUTH = '/wiserdoor/data/ciamtoken/';
export const PATH_API_USER = '/wiserdoor/data/users/';
export const PATH_API_ACCOUNT = '/wiserdoor/data/accounts/';
export const PATH_API_DEVICE = '/wiserdoor/data/devices/';
export const PATH_API_RSTPWD = '/wiserdoor/data/resetpwd/';
export const PATH_API_VERICODE = '/wiserdoor/data/vericode/';
export const PATH_WEB_INDEX = '/';
export const PATH_WEB_HOME = '/home';
export const PATH_WEB_LOGIN = '/login';
export const PATH_WEB_CREATE_NEW_ACCOUNT = '/createNewAccount';
export const PATH_WEB_RESET_PASSWORD = '/resetPassword';
export const PATH_WEB_DEVICE = '/home/device';
export const PATH_WEB_DEVICE_PARAM = '/home/device/:code';
export const PATH_WEB_ACCOUNT = '/home/account';
export const PATH_WEB_404 = '/404';
export const PATH_WEB_USE = '/use';
export const PATH_WEB_RULE = '/rule';
export const PATH_WEB_USEUS = '/useUs';
export const PATH_WEB_RULEUS = '/ruleUs';
export const PATH_WEB_LOGOUT = '/logout';
